module.exports = __webpack_public_path__ + "img/paciente_cita_01.1ba1a066.png";